module.exports = __webpack_public_path__ + "static/media/info-white-filled.297a75db.svg";